export const isMobile = () => {
  return window.matchMedia("(max-width:768px)").matches
}
